import router from "../router";

import {
  requestUpdateSkinBanner,
  requestSkinBannerDetail
} from "@/apis/skinBanner_api";

const state = {
  skinBannerDetail: {}
};

const getters = {
  getSkinBannerDetail(state) {
    return state.skinBannerDetail;
  }
};

const mutations = {
  SKIN_INIT() {
    state.skinBannerDetail = null;
  },
  SKIN_BANNER_DETAIL(state, data) {
    const { resultSkinBanner } = data;
    state.skinBannerDetail = data.resultSkinBanner;
    state.skinBannerDetail.logoImg = null;
    state.skinBannerDetail.backImg = null;
    state.skinBannerDetail.fontImg = null;
    state.skinBannerDetail.bannerList = [];

    resultSkinBanner.SkinBannerFiles.forEach(element => {
      if (element.type === "logo") {
        state.skinBannerDetail.logoImg = element;
      } else if (element.type === "background") {
        state.skinBannerDetail.backImg = element;
      } else if (element.type === "font") {
        if (!state.skinBannerDetail.logoImg) {
          state.skinBannerDetail.logoImg = element;
        } else {
          state.skinBannerDetail.fontImg = element;
        }
      } else {
        state.skinBannerDetail.bannerList.push(element);
      }
    });

    if (resultSkinBanner.CorpId) {
      resultSkinBanner.type = "corp";
    } else {
      resultSkinBanner.type = "funeral";
    }
  }
};

const actions = {
  async REQUEST_APPLY_SKIN_BANNER({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const res = await requestUpdateSkinBanner(parameter);
      const { data } = res;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      alert(data.message);
      router.push({ path: `/${parameter.type}/skinBanner` });
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_SKIN_BANNER_DETAIL({ commit }, param) {
    try {
      commit("START_LOADING");
      const res = await requestSkinBannerDetail(param);

      const { data } = res;

      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("SKIN_BANNER_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
